import { useEffect } from 'react';

/**
 * Inyecta un bloque JSON-LD en document.head y lo elimina al desmontar.
 */
const JsonLd = ({ id, data }) => {
  useEffect(() => {
    if (!data) return undefined;
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    el.textContent = JSON.stringify(data);
    document.head.appendChild(el);
    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, [id, data]);

  return null;
};

export default JsonLd;
